import React, { useState, useEffect, useRef } from "react";

import * as S from './CommonModal.styles';

const CommonModal = ({
  closeModal,
  closeBtn,
  modalWidth,
  centerMode,
  children,
  customClass,
}) => {
  const inputEl = useRef(null);
  const [centerPos, setCenterPos] = useState("");

  useEffect(() => {
    if (window.outerHeight - 100 > inputEl.current.clientHeight) {
      setCenterPos("centerMode");
    } else {
      setCenterPos("");
    }

    document.querySelector("body").classList.add("bodyFixed");

    return () => {
      document.querySelector("body").classList.remove("bodyFixed");
    };
  }, []);

  return (
    <S.Container>
    <div
      className={`cm__modalWraper ${centerPos} ${
        customClass ? customClass : ""
      }`}
    >
      <div className="cm__modal" style={{ width: modalWidth }} ref={inputEl}>
        {closeBtn && (
          <span
            className={`cm__modalClose ${centerPos ? "modalCloseCenter" : ""}`}
            onClick={closeModal}
          />
        )}
        <div className="cm__modalContent">{children}</div>
      </div>
      <div className="cm__modalBackdrop" onClick={closeModal} />
    </div>
    </S.Container>
  );
};

export default CommonModal;
